import React, { lazy, Suspense } from 'react';

const DesktopApp = lazy(() => import('../desktop/DesktopApp'));

export default function DesktopPage() {
  return (
    <Suspense fallback={<div style={{ background: '#000', height: '100vh', width: '100vw' }} />}>
      <DesktopApp />
    </Suspense>
  );
}
